import React from "react";
import HiringFooter from "./HiringFooter";
import JobHead from "./job_description/JobHead";
import PageContent from "./job_description/PageContent";
import JobClosed from "./job_description/components/JobClosed";

const JobDescription = (props) => {
  const {
    galleryImages,
    jobTeamMembers,
    statedValues,
    interviewingProcess,
    permalink,
    name,
    description,
    url,
    pointerEvents,
    baseUrl,
    logo,
    job,
    sections
  } = props;
  const { id: jobId } = job;

  const isPublished = job["jobdesc_published"];
  const archiveDate = job["archive_date"];

  const tabs = [].concat(
    sections
      .filter(({ show_heading: show }) => show === true)
      .map(({ heading: name, id }) => ({ name, id }))
      .concat(
        galleryImages.length > 0 ? [{ name: "Gallery", id: "gallery" }] : []
      )
      .concat(
        jobTeamMembers.length > 0 ? [{ name: "The Team", id: "team" }] : []
      )
      .concat(
        statedValues.length > 0 ? [{ name: "Our Values", id: "values" }] : []
      )
  );

  const companyImageGallery = galleryImages.map((galleryImage) => ({
    id: galleryImage.id,
    image: galleryImage.image.url
  }));

  const hiringManager = jobTeamMembers
    .filter((teamMember) => teamMember.is_hiring_manager)
    .map(({ id, staff_name, staff_job_title, staff_image, staff_url }) => ({
      id: id,
      name: staff_name,
      title: staff_job_title,
      image: staff_image?.url || null,
      url: staff_url
    }));

  const team = jobTeamMembers
    .filter((teamMember) => !teamMember.is_hiring_manager)
    .map(({ id, staff_name, staff_job_title, staff_image, staff_url }) => ({
      id: id,
      name: staff_name,
      title: staff_job_title,
      image: staff_image?.url || null,
      url: staff_url
    }));

  const values = statedValues.map(({ id, name, image, stated_value }) => ({
    id: id,
    title: name,
    image: image && "url" in image ? image["url"] : null,
    description: stated_value
  }));

  const hiringProcess = interviewingProcess.map(
    ({ id, name, duration_in_mins }, i) => ({
      id,
      stage: i + 1,
      name,
      duration_in_mins
    })
  );

  const applyUrl = `${baseUrl}/${jobId}/apply`;

  return (
    <div
      className={
        pointerEvents === false ? "pointer-events-none select-none" : ""
      }
    >
      <JobHead
        name={name}
        logo={logo}
        baseUrl={baseUrl}
        url={url}
        applyUrl={applyUrl}
        job={job}
        colorHeaderBg={props.color_header_bg}
        colorHeaderText={props.color_header_text}
        colorButtonBg={props.color_button_bg}
        colorButtonText={props.color_button_text}
        colorHighlightText={props.color_highlight_text}
        colorHighlightIcon={props.color_highlight_icon}
        permalink={permalink}
        tabs={tabs}
        canApply={isPublished || pointerEvents === false}
      />
      {(!isPublished || archiveDate) && pointerEvents && <JobClosed />}
      {((isPublished && !archiveDate) || pointerEvents === false) && (
        <PageContent
          name={name}
          description={description}
          applyUrl={applyUrl}
          job={job}
          sections={sections}
          colorButtonBg={props.color_button_bg}
          colorButtonText={props.color_button_text}
          colorHighlightBg={props.color_highlight_bg}
          colorHighlightText={props.color_highlight_text}
          colorHighlightIcon={props.color_highlight_icon}
          colorSectionHeaderText={props.color_section_header_text}
          colorSectionText={props.color_section_text}
          companyImageGallery={companyImageGallery}
          hiringManager={hiringManager}
          team={team}
          values={values}
          hiringProcess={hiringProcess}
          tabs={tabs}
        />
      )}
      <HiringFooter />
    </div>
  );
};

export default JobDescription;
